"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ReliabilityDetails = require("./components/ReliabilityDetails");
Object.keys(_ReliabilityDetails).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ReliabilityDetails[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ReliabilityDetails[key];
    }
  });
});
var _ReliabilityDesktop = require("./components/ReliabilityDesktop");
Object.keys(_ReliabilityDesktop).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ReliabilityDesktop[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ReliabilityDesktop[key];
    }
  });
});
var _ReliabilityMobile = require("./components/ReliabilityMobile");
Object.keys(_ReliabilityMobile).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ReliabilityMobile[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ReliabilityMobile[key];
    }
  });
});